import { useHolo } from "@/lib/holo";

export default function HoloCard({ item, onSelect, children }) {
  const { innerRef, activate, deactivate, onPointerMove } = useHolo();

  return (
    <button
      type="button"
      data-testid={`gallery-card-${item.id}`}
      onClick={() => onSelect(item)}
      onPointerDown={activate}
      onPointerUp={deactivate}
      onPointerLeave={deactivate}
      onPointerCancel={deactivate}
      onPointerMove={onPointerMove}
      className="holo-card group relative h-[420px] w-[270px] shrink-0 snap-start overflow-visible rounded-2xl border border-white/10 bg-transparent text-left sm:h-[480px] sm:w-[330px] lg:w-[380px]"
      aria-label={`${item.title} — voir en grand`}
    >
      <div ref={innerRef} className="holo-inner overflow-hidden rounded-2xl border border-white/10 bg-[#100e19]">
        {children}
        <div className="holo-foil" aria-hidden="true" />
      </div>
    </button>
  );
}
